<template>
  <div class="login-box1-wrapper" ref="loginWrapper">
    <div class="wechat-login-icon" @click="wxLogin" v-if="pageConfig.wxCode && type !== 'weChatLogin'">
      <el-tooltip class="item" effect="dark" :content="$t('使用微信扫码登录')" placement="bottom">
        <img src="../img/code.png" alt="">
      </el-tooltip>
    </div>
    <fanjian v-show="pageConfig.showFontSwitch" @changeFanjian="emitChangeFanjian"></fanjian>
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" v-if="type === 'loginForm'">
      <div class="title">{{ pageConfig.loginBoxText || $t('欢迎登录平台') }}</div>
      <el-form-item prop="username">
        <el-input
            style="width:380px;"
            type="text"
            :placeholder="$t('请输入用户名')"
            prefix-icon="el-icon-user-solid"
            v-model="loginForm.username">
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
            style="width:380px;"
            type="password"
            :placeholder="$t('请输入密码')"
            prefix-icon="el-icon-s-goods"
            @keyup.enter.native="handleLogin"
            v-model="loginForm.password">
          <el-button @click="changeType('passwordForm')" style="margin-right:24px;margin-top:4px;" slot="suffix" type="text">{{$t('忘记密码')}}</el-button>
        </el-input>
      </el-form-item>

      <!--新增验证码登陆-->
      <el-form-item prop="code" v-if="pageConfig.showCode"
                    :rules="NODE_ENV === 'production'?[
            { required: true, message: $t('请输入验证码'), trigger: 'blur' }
          ]:[]"
      >
        <el-input
            style="width:250px;"
            type="text"
            :placeholder="$t('输入验证码')"
            v-model="loginForm.code">
          <i slot="prefix" style="font-size:22px;margin-left:2px;" class="iconfont icon-renzhengdunpaianquanbaozhangzhibao" />
        </el-input>
        <el-button v-if="time === 0"  @click="getVerificationCode(loginForm.username)" style="margin-left:10px;margin-top:4px;" type="text">{{ $t('获取验证码') }}</el-button>
        <span style="display:inline-block;color: #848383;"  v-else class="show-pwd">
              {{time}}{{$t('S后重新获取')}}
          </span>
      </el-form-item>

<!--      <el-form-item prop="code" v-if="pageConfig.showCode"-->
<!--          :rules="NODE_ENV === 'production'?[-->
<!--            { required: true, message: $t('请输入验证码'), trigger: 'blur' }-->
<!--          ]:[]"-->
<!--      >-->
<!--        <el-input-->
<!--            style="width:150px;"-->
<!--            type="text"-->
<!--            :placeholder="$t('输入验证码')"-->
<!--            v-model="loginForm.code">-->
<!--          <i slot="prefix" style="font-size:22px;margin-left:2px;" class="iconfont icon-renzhengdunpaianquanbaozhangzhibao" />-->
<!--        </el-input>-->
<!--        <div class="login-code">-->
<!--          <img class="code_posi"  @click="getVerifyCodeUrl()" :src="verifyCodeUrl" alt="" />-->
<!--        </div>-->
<!--        <el-button @click="getVerifyCodeUrl()" style="margin-left:10px;margin-top:4px;" type="text">{{ $t('换一组') }}</el-button>-->
<!--      </el-form-item>-->
      <el-checkbox style="margin-left:34px;" v-model="rememberPassword">{{ $t('记住密码')}} </el-checkbox>
      <el-button type="primary" class="lodin-btn" @click.native.prevent="handleLogin">
        {{ $t('登录') }}</el-button>
      <div class="footer-btn-wrapper">
        <el-button v-show="pageConfig.showRegistAgreement" @click="changeType('registerForm')" style="float:left;margin-left:20px;" type="text">{{  $t('注册新用户') }}</el-button>
        <div class="qr-code-hover" v-if="pageConfig.showQrcode">
          <el-button style="float:right;margin-right:20px;" type="text">{{ $t('APP二维码下载') }}</el-button>
          <div class="qrcode-wrapper">
            <qr-code></qr-code>
          </div>
        </div>
      </div>
      <div style="opacity:0;">
        test
      </div>
      <div class="web">
        <span class="red">*</span>
        {{$t('推荐使用')}}<a class="link" href="https://www.google.cn/chrome/" target="_blank">Google</a>
        {{$t('或')}}<a class="link" href="https://www.firefox.com.cn/" target="_blank">Firefox</a>
      </div>
    </el-form>
    <el-form ref="registerForm" :rules="registerRules" :model="registerForm" v-if="type === 'registerForm'">
      <div class="title">{{ $t('用户注册') }}</div>
      <el-form-item prop="username">
        <el-input
            style="width:380px;"
            type="text"
            :placeholder="$t('请输入用户名')"
            prefix-icon="el-icon-user-solid"
            v-model="registerForm.username">
        </el-input>
      </el-form-item>
      <el-form-item prop="telPhone">
        <el-input
            class="phone-input"
            style="width:380px;"
            type="text"
            :placeholder="$t('请输入手机号码')"
            v-model="registerForm.telPhone">
          <span slot="prefix">
            <i style="font-size:22px;margin-left:2px;" class="iconfont icon-shouji" />
            <phoneCodeSelect v-model="registerForm.areaCode" style="margin-left:2px;"></phoneCodeSelect>
          </span>
          <el-button v-if="time === 0" @click="getMessageCode()" style="margin-right:24px;margin-top:4px;" slot="suffix" type="text">	{{$t('获取验证码')}}</el-button>
          <span slot="suffix" style="display:inline-block;margin-right:24px;margin-top:6px;color: #848383;" v-else class="show-pwd">
              {{time}}{{$t('后重新获取')}}
          </span>
        </el-input>
      </el-form-item>
      <el-form-item prop="telPhone">
        <el-input
            style="width:380px;"
            type="text"
            :placeholder="$t('请输入短信验证码')"
            v-model="registerForm.code">
          <i slot="prefix" style="font-size:22px;margin-left:2px;" class="iconfont icon-youxiang" />
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
            style="width:380px;"
            type="password"
            :placeholder="$t('设置6至20位登录密码')"
            prefix-icon="el-icon-s-goods"
            v-model="registerForm.password">
        </el-input>
      </el-form-item>
      <el-form-item prop="password2">
        <el-input
            style="width:380px;"
            type="password"
            :placeholder="$t('确认密码')"
            prefix-icon="el-icon-s-goods"
            v-model="registerForm.password2">
        </el-input>
      </el-form-item>
      <el-checkbox style="margin-left:34px;" v-model="agree">{{$t('勾选同意')}}</el-checkbox>
      <a style="color:#2D73C7;" @click="showModal = true" href="javascript:void(0);">《{{$t('用户服务协议')}}》</a>
      <el-button type="primary" class="lodin-btn" @click="handleRegister()">
        {{$t('注册') }}</el-button>
      <div class="footer-btn-wrapper">
        <el-button @click="changeType('loginForm')" style="float:left;margin-left:20px;" type="text">{{$t('使用已有帐户登录')}}</el-button>
      </div>
    </el-form>
    <el-form ref="passwordForm" :rules="passwordRules" :model="passwordForm" v-if="type === 'passwordForm'">
      <div class="title">{{ $t('找回密码') }}</div>
      <el-form-item prop="telPhone">
        <el-input
            class="phone-input"
            style="width:380px;"
            type="text"
            :placeholder="$t('请输入注册时的手机号码')"
            v-model="passwordForm.telPhone">
          <span slot="prefix">
            <i style="font-size:22px;margin-left:2px;" class="iconfont icon-shouji" />
            <phoneCodeSelect v-model="passwordForm.areaCode" style="margin-left:2px;"></phoneCodeSelect>
          </span>
          <el-button v-if="forgettime === 0" @click="getMessageCodeForget()" style="margin-right:24px;margin-top:4px;" slot="suffix" type="text">	{{$t('获取验证码')}}</el-button>
          <span slot="suffix" style="display:inline-block;margin-right:24px;margin-top:6px;color: #848383;" v-else class="show-pwd">
              {{forgettime}}{{$t('后重新获取')}}
          </span>
        </el-input>
      </el-form-item>
      <el-form-item prop="telPhone">
        <el-input
            style="width:380px;"
            type="text"
            :placeholder="$t('请输入短信验证码')"
            v-model="passwordForm.code">
          <i slot="prefix" style="font-size:22px;margin-left:2px;" class="iconfont icon-youxiang" />
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
            style="width:380px;"
            type="password"
            :placeholder="$t('设置6至20位登录密码')"
            prefix-icon="el-icon-s-goods"
            v-model="passwordForm.password">
        </el-input>
      </el-form-item>
      <el-form-item prop="password2">
        <el-input
            style="width:380px;"
            type="password"
            :placeholder="$t('确认密码')"
            prefix-icon="el-icon-s-goods"
            v-model="passwordForm.password2">
        </el-input>
      </el-form-item>
      <el-button type="primary" class="lodin-btn" @click="handlePassword()">
        {{ $t('重设密码') }}</el-button>
      <div class="footer-btn-wrapper">
        <el-button @click="changeType('loginForm')" style="float:left;margin-left:20px;" type="text">{{$t('返回登录')}}</el-button>
      </div>
    </el-form>
    <div class="wechat-login" v-if="type === 'weChatLogin'">
      <div class="title">
        <el-button type="text" style="position: absolute;top:10px;right:10px;" @click="backLogin">{{ $t('返回登录') }}</el-button>
        {{ $t('微信登录') }}
      </div>
      <img :src="WxQR" alt="">
      <div style="text-align: center;margin-top:10px;color:#9c9c9c;">{{ $t('使用微信扫码登录') }}</div>
    </div>
    <user-agreement v-if="showModal" :showModal.sync="showModal" @check="checkAgreement"></user-agreement>
  </div>
</template>

<script>
import baseMixin from "../mixins/baseMixin";
import loginMixin from "../mixins/loginMixin";
import registerMixin from "../mixins/registerMixin";
import passwordMixin from "../mixins/passwordMixin";
export default {
  mixins: [baseMixin, loginMixin, registerMixin, passwordMixin]
}
</script>

<style lang="scss">
.login-box1-wrapper {
  .el-input__inner {
    height: 44px!important;
    background: #F3F3F3;
    border-radius: 29px 29px 29px 29px;
    border: none!important;
    padding-left: 60px!important;
    color: #a5a5a5;
    font-size: 1rem;
    &::placeholder {
      color: #cccccc;
      font-size:1rem;
    }
  }
  .phone-input >.el-input__inner {
      height: 44px!important;
      background: #F3F3F3;
      border-radius: 29px 29px 29px 29px;
      border: none!important;
      padding-left: 150px!important;
      color: #a5a5a5;
      font-size: 1rem;
      &::placeholder {
        color: #cccccc;
        font-size:1rem;
      }
  }
  .el-form-item__error {
    font-size: 0.85rem;
    padding-left: 60px;
  }
  .el-input__prefix {
    left: 28px!important;
    right: auto!important;
    font-size: 22px;
    line-height:44px;
    color:#cccccc;
  }
  .el-button--text {
    font-size: 1rem;
    color:#2D73C7;
    &:hover{
      color:#2D73C7;
    }
    &:focus{
      color:#2D73C7;
    }
  }
  .el-checkbox__input .el-checkbox__inner {
    font-size: 1rem;
    background-color: #ffffff;
    border-color: #2D73C7;
    width: 1rem;
    height: 1rem;
    &:after {
      height: 0.5rem;
      left: 0.28rem;
    }
  }
  .el-checkbox__input + .el-checkbox__label {
    font-size: 1rem;
    color: #a5a5a5;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #2D73C7;
    border-color: #2D73C7;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #2D73C7;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #2D73C7;
  }
}
</style>

<style lang="scss" scoped>
  .login-box1-wrapper {
    position: relative;
    font-size: 1rem;
    width: 450px;
    background: #fff;
    padding: 40px 35px 30px 35px;
    border-radius: 6px;
    .wechat-login-icon{
      position: absolute;
      top: 25px;
      right: 25px;
      cursor: pointer;
    }
    .wechat-login {
      height: 386px;
      background: #fff;
      border-radius: 3px;
      padding: 20px;
      text-align: center;
    }
    .title{
      text-align: center;
      font-size: 28px;
      color: #2D73C7;
      font-weight: 500;
      margin-bottom:26px;
    }
    .login-code{
      text-align: center;
      display: inline-block;
      margin-left:22px;
      vertical-align: middle;
      .code_posi{
        vertical-align: middle;
      }
    }
    .lodin-btn{
      width: 380px;
      height: 50px;
      background: #2D73C7;
      border-radius: 27px 27px 27px 27px;
      font-size:1.14rem;
      font-weight:500;
      line-height:28px;
      color:#fff;
      text-align: center;
      border: none;
      margin-top:38px;
    }
    .footer-btn-wrapper{
      height: 30px;
      .qr-code-hover {
        .qrcode-wrapper {
          padding: 10px;
          background: #ffffff;
          position: absolute;
          z-index: 11;
          right: 50px;
          display: none;
          margin-top: 40px;
        }
        &:hover {
          .qrcode-wrapper {
            display: block;
          }
        }
      }
    }
    .web {
      text-align: center;
      width:100%;
      .link {
        box-sizing: border-box;
        display: inline;
      }
    }
  }
</style>